import {
  FOUND_DECLINATION_ARR_RU,
  RESULT_DECLINATION_ARR_RU,
  LangKey,
  RESULT_DECLINATION_ARR_ENG,
} from 'config';
import { t } from 'i18next';
import { localStorageManager } from 'services/localStorage';
import { ISearchDiscount } from 'interfaces/search.model';

export const engDeclination = (num: number, arr: string[]) => {
  if (num === 1) return arr[0];
  return arr[1];
};

export const rusDeclination = (num: number, arr: string[]) => {
  const mod100 = Math.abs(num) % 100;
  const mod10 = mod100 % 10;
  if (mod100 > 10 && mod100 < 20) return arr[2];
  if (mod10 > 1 && mod10 < 5) return arr[1];
  if (mod10 === 1) return arr[0];
  return arr[2];
};

export const calculateDeclinationResultTitle = (num: number = 0) => {
  const language = localStorageManager.getLanguage();

  const foundStr =
    language === LangKey.ru
      ? rusDeclination(num, FOUND_DECLINATION_ARR_RU)
      : t('search.found');

  const resultStr =
    language === LangKey.ru
      ? rusDeclination(num, RESULT_DECLINATION_ARR_RU)
      : engDeclination(num, RESULT_DECLINATION_ARR_ENG);

  return `${foundStr} ${num} ${resultStr}`;
};

export type IDiscountsGroupByCategory = {
  [key: string]: ISearchDiscount[];
};

export const groupByCategory = (discounts: ISearchDiscount[]) => {
  const language = localStorageManager.getLanguage();

  return discounts.reduce((result: IDiscountsGroupByCategory, item) => {
    const categoryKey =
      language === LangKey.ru
        ? item.categoryTitle
        : t(`categories.${item.categoryTitle}`);

    return { ...result, [categoryKey]: [...(result[categoryKey] || []), item] };
  }, {});
};
